import { observer } from 'mobx-react-lite'
import { type RatingsViewModel } from '@/features/jobs/details/ratings/RatingsViewModel'
import { RatingsNotificationBar } from '@/features/jobs/details/ratings/components/RatingsNotificationBar'

export interface RatingsNotificationBarContainerProps {
  vm: RatingsViewModel
}

export const RatingsNotificationBarContainer = observer(
  function RatingsNotificationBarContainer({
    vm,
  }: RatingsNotificationBarContainerProps) {
    if (!vm.canSeeRatingNotificationBar) return null
    const testId = 'ratings-notification-bar'
    return (
      <RatingsNotificationBar
        onShowRateProDialog={vm.showRateProDialog}
        showRateDialogButtonTestId={`${testId}-show-rate-dialog`}
        testId={testId}
      />
    )
  },
)
